<template>
    <div class="alerts-container text-end">
        <transition-group name="slide-right" tag="div">
            <div
                v-for="alert in $alertStore.alerts"
                :key="alert.id"
                class="alert-wrapper"
            >
                <div
                    class="alert d-inline-flex justify-content-between align-items-start text-start"
                    :class="alert.class"
                >
                    <div class="alert-content">
                        <div class="alert-icon">
                            <i class="fi" :class="alert.icon"></i>
                        </div>
                        <div class="alert-text">{{ alert.text }}</div>
                    </div>

                    <span
                        type="button"
                        class="alert-close"
                        data-dismiss="alert"
                        aria-label="Close"
                        @click="dismiss(alert.id)"
                    >
                        <i class="fi fi-x"></i>
                    </span>

                    <!-- Progress bar for auto-dismiss alerts -->
                    <div
                        v-if="alert.autoDismiss"
                        class="progress-bar"
                        :class="`${alert.class}-progress-bar`"
                        :style="getProgressBarStyle(alert)"
                    ></div>
                </div>
            </div>
        </transition-group>
    </div>
</template>

<script>
export default {
    name: 'AppAlerts',
    data() {
        return {};
    },

    methods: {
        dismiss(alertId) {
            this.$alertStore.remove(alertId);
        },

        getProgressBarStyle(alert) {
            return {
                background: `${alert.class}-progress-bar`,
                animationDuration: `${alert.duration}ms`,
            };
        },
    },
};
</script>

<style scoped>
.alerts-container {
    position: absolute;
    top: 0;
    right: 0;
    margin: 5rem 2rem;
    z-index: var(--z-index-alerts);
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 70%;
    padding-right: 0.5rem;
}

.alert-wrapper {
    position: relative;
}

.alert {
    font-size: 1em;
    padding: 0.5rem;
    position: relative;
    min-width: 20rem;
    width: 100%;
    max-width: min(40rem, 100%);
    padding-bottom: 16px;
    overflow: hidden;
}

.alert-content {
    display: flex;
    align-items: flex-start;
    flex: 1;
    min-width: 0;
    line-height: 1.4;
    font-size: 1rem;
}

.alert-icon {
    flex-shrink: 0;
    margin-right: 0.5rem;
}

.alert-text {
    flex: 1;
    word-break: break-word;
    /* Allow text to wrap naturally */
    white-space: normal;
    overflow-wrap: break-word;
}

.alert-close {
    flex-shrink: 0;
    background: none;
    border: none;
    margin-left: 0.5rem;
    cursor: pointer;
    opacity: 0.7;
    transition: opacity 0.2s ease;
    line-height: 1;
}

.alert-close:hover {
    opacity: 1;
}

.progress-bar {
    content: '';
    position: absolute;
    bottom: 4px;
    left: 4px;
    height: 4px;
    border-radius: 4px;
    width: 0;
    animation: progressAnimation linear forwards;
}

.alert-success-progress-bar {
    background-color: #5b8c5b;
}

.alert-danger-progress-bar {
    background-color: #8c3f3f;
}

.alert-info-progress-bar {
    background-color: #547c99;
}

.alert-warning-progress-bar {
    background-color: #ffcc00;
}

/* Animation for progress bar */
@keyframes progressAnimation {
    from {
        width: calc(100% - 8px);
    }
    to {
        width: 0;
    }
}

@media only screen and (max-width: 767.98px) {
    .alerts-container {
        max-width: 100%;
    }

    .alert {
        max-width: 100%;
        min-width: 0;
    }
}

/* Scrollbar behavior */
.alerts-container::-webkit-scrollbar {
    width: 3px;
    opacity: 0;
    transition: all 0.3s ease;
}

.alerts-container:hover::-webkit-scrollbar {
    opacity: 1;
}

.alerts-container::-webkit-scrollbar-track {
    background: var(--neutral-450);
    border-radius: var(--radius-sm);
}

.alerts-container::-webkit-scrollbar-thumb {
    background: var(--neutral-600);
    border-radius: var(--radius-sm);
}

.alerts-container::-webkit-scrollbar-thumb:hover {
    background: var(--neutral-700);
}

/* Slide from right animations */
.slide-right-enter-active {
    transition: all 0.4s ease;
}
.slide-right-leave-active {
    transition: all 0.4s ease;
    position: absolute;
    width: 100%;
}
.slide-right-move {
    transition: transform 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}
.slide-right-enter-from,
.slide-right-leave-to {
    opacity: 0;
    transform: translateX(100%);
}
</style>
